export default "__VITE_ASSET__CAF0vWS6__"